import { getAvatarBackColor, getPersonInitials } from "helpers/randomHelpers";
import React from "react";

const AvatarCircle = (props) => {
  return (
    <div
      className={`avatarCircle form-shadow ${props.borderStyle} ${
        props.children ? "invisible-background" : ""
      }`}
      style={{ backgroundColor: getAvatarBackColor(props.given_name) }}
    >
      {props.children ? (
        props.children
      ) : (
        <div>{getPersonInitials(props.given_name, props.family_name)}</div>
      )}
    </div>
  );
};

AvatarCircle.defaultProps = {
  pic: null,
  family_name: "",
  given_name: "",
};

export default AvatarCircle;
